import { Box } from '@mui/material'
import UnderLine from 'components/common/Underline'
import React from 'react'

// Money columns are right-aligned and formatted; everything else reads as plain text.
const MONEY = ['selling_price', 'tax_amount', 'amount']
const RIGHT = [...MONEY, 'quantity', 'tax']

const money = (v) => {
    const n = Number(v)
    if (!Number.isFinite(n)) return '-'
    return n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

const cell = (row, field) => {
    const v = row?.[field]
    if (v === null || v === undefined || v === '') return '-'
    return MONEY.includes(field) ? money(v) : String(v)
}

/**
 * Was rendering every cell as a *disabled MUI TextField*, so the printed invoice came
 * out covered in grey rounded input boxes. Plain table cells print cleanly, and the
 * totals sit in a <tfoot> so the browser repeats it correctly across page breaks.
 */
const LabourEstimateTable = ({ data, column, title }) => {
    const total = (data || []).reduce((sum, r) => sum + (Number(r?.amount) || 0), 0)

    return (
        <div className='table-body'>
            <Box fontSize={'1.1rem'} className='flex ai-center'>
                <Box>{title}<UnderLine /></Box>
            </Box>
            <table className='table print-table'>
                <thead className='thead'>
                    <tr>
                        {column.map((field, i) => (
                            <th key={i} className={RIGHT.includes(field.field) ? 'num' : ''}>{field.title}</th>
                        ))}
                    </tr>
                </thead>
                <tbody className='tbody'>
                    {data?.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {column.map((col, colIndex) => (
                                <td key={colIndex} className={RIGHT.includes(col.field) ? 'num' : ''}>
                                    {cell(row, col.field)}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
                {data?.length ? (
                    <tfoot>
                        <tr className='total-row'>
                            <td colSpan={Math.max(column.length - 1, 1)} className='num'>{title} total</td>
                            <td className='num'>{money(total)}</td>
                        </tr>
                    </tfoot>
                ) : null}
            </table>
        </div>
    )
}

export default LabourEstimateTable
